import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { HeaderWithNextButtonLayout, SubmitButton } from "@components";
import { BasicInfo, JobInfo, JoiningInfo } from "./components";

import { useGeneralInfo } from "@hooks/HRM/employee/useGeneralInfo";

import { GeneralInfoType } from "@type/HRM/general-info";

import { generalInfoValidation } from "@validations/HRM/employee/generalInfoValidation";

export interface GeneralInfoPropsType {
  id: number | null;
  setSearchParams?: Function;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  setErrorSubtitle: (arg: string) => void;
  isProfileDisabled: boolean;
}

function GeneralInfo({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  isProfileDisabled,
  setErrorSubtitle,
}: GeneralInfoPropsType) {
  const {
    generalInfo,
    changeGeneralInfo,
    getGeneralInfoRequestOngoing,
    updateGeneralInfoRequestOngoing,
    updateGeneralInfoSuccess,
    updateGeneralInfoFailed,
  } = useGeneralInfo(id);

  const methods = useForm<GeneralInfoType>({
    resolver: yupResolver(generalInfoValidation),
    values: {
      ...(generalInfo && {
        ...generalInfo,
        onProbation: generalInfo?.onProbation === true ? "yes" : "no",
      }),
    } as GeneralInfoType,
  });
  const { handleSubmit } = methods;

  const onSubmit: SubmitHandler<GeneralInfoType> = (data: any) => {
    const newEmployee = {
      ...data,
      onProbation: data?.onProbation === "yes" ? true : false,
    };
    changeGeneralInfo(newEmployee);
  };

  let isLoading =
    getGeneralInfoRequestOngoing || updateGeneralInfoRequestOngoing;

  useEffect(() => {
    setIsSuccessModalOpen(updateGeneralInfoSuccess);
    setIsErrorModalOpen(updateGeneralInfoFailed);
    if (updateGeneralInfoFailed) {
      setErrorSubtitle(generalInfo?.response?.data?.message);
    } else {
      setErrorSubtitle("");
    }
  }, [updateGeneralInfoSuccess, updateGeneralInfoFailed]);

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={handleSubmit(onSubmit)}>
        <HeaderWithNextButtonLayout
          title="EMPLOYEE.GENERAL_INFO.HEADING"
          subtitle="EMPLOYEE.GENERAL_INFO.DESCRIPTION"
          action={() => changeActiveTab(1)}
        >
          <BasicInfo isProfileDisabled={isProfileDisabled} />
          <JobInfo isProfileDisabled={isProfileDisabled} />
          <JoiningInfo isProfileDisabled={isProfileDisabled} />
          <div className="row py-10">
            <div className="text-end col-lg-10">
              <SubmitButton
                label="save"
                fill="outline"
                loading={isLoading}
                disabled={isProfileDisabled}
              />
            </div>
          </div>
        </HeaderWithNextButtonLayout>
      </form>
    </FormProvider>
  );
}

export default GeneralInfo;
